import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, FormLabel } from '@chakra-ui/react';
import { formatAssetsUrl, akamaiImageLoader, isIVMEnabled } from '@whitbread-eos/utils';
import Image from 'next/image';
import Select from 'react-select';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Multiselect = _ref => {
  var name = _ref.name,
    dataTestId = _ref.dataTestId,
    options = _ref.options,
    styles = _ref.styles,
    value = _ref.value,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    isMulti = _ref.isMulti,
    isClearable = _ref.isClearable,
    closeMenuOnSelect = _ref.closeMenuOnSelect,
    isDisabled = _ref.isDisabled;
  return _jsxs(Box, {
    position: "relative",
    children: [_jsx(FormLabel, _objectSpread(_objectSpread({
      "data-testid": "".concat(dataTestId, "-label"),
      pos: "absolute"
    }, labelStyle(value)), {}, {
      htmlFor: name,
      children: placeholder
    })), _jsx(Select, {
      "data-testid": "".concat(dataTestId, "-multiSelect"),
      options: options,
      value: value,
      name: name,
      onChange: onChange,
      styles: styles,
      closeMenuOnSelect: closeMenuOnSelect,
      placeholder: placeholder,
      formatOptionLabel: CustomOption,
      isMulti: isMulti,
      isClearable: isClearable,
      isDisabled: isDisabled,
      hideSelectedOptions: true,
      components: {
        IndicatorSeparator: () => null,
        ClearIndicator: () => null
      }
    })]
  });
};
export default Multiselect;
var CustomOption = _ref2 => {
  var label = _ref2.label,
    image = _ref2.image,
    value = _ref2.value;
  return _jsxs("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    },
    children: [image && _jsx(Image, {
      src: formatAssetsUrl(image),
      width: "24",
      height: "24",
      alt: "multi-select-img-".concat(value),
      loader: isIVMEnabled() ? akamaiImageLoader : undefined
    }), _jsx("label", {
      style: {
        marginLeft: '10px'
      },
      children: label
    })]
  });
};
var labelStyle = function labelStyle(value) {
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return {
    h: '1.25rem',
    w: 'fit-content',
    fontSize: 'sm',
    align: 'center',
    px: 'xs',
    fontWeight: 'normal',
    ml: '0.750rem',
    top: '-0.5rem',
    backgroundColor: 'baseWhite',
    zIndex: '1',
    color: error ? 'error' : 'darkGrey1',
    display: value ? 'block' : 'none',
    _focus: {
      color: error ? 'error' : 'primary',
      display: 'block'
    },
    lineHeight: '1'
  };
};